import { PROJECT_VARIANTS } from '../../constants';
import * as scoutActions from '../../redux/scout/scoutActions';
import * as consumerScoutActions from '../../redux/consumer/scout/consumerScoutActions';

const scoutActionsMapping = {
  getData: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getScoutFormData,
  },
  getAllMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getAllMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getAllMessagesConsumer,
  },
  getSelectedMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getSelectedMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getSelectedMessagesConsumer,
  },
  getFinalMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getFinalMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getFinalMessagesConsumer,
  },
  getScreenedMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getScreenedMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getScreenedMessagesConsumer,
  },
  getBackupMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getBackupMessages,
  },
  getMessagesByTab: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getMessagesByTab,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getMessagesByTab,
  },
  generateMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.generateMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.generateMessagesConsumer,
  },
  generateMore: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.generateMore,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.generateMoreConsumer,
  },
  compressMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.compressMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.compressMessagesConsumer,
  },
  reply: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.replyScout,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.replyScoutConsumer,
  },
  resetSession: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.resetSession,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.resetSessionConsumer,
  },
  selectMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.selectMessage,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.selectMessageConsumer,
  },
  deleteMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.deleteMessage,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.deleteMessageConsumer,
  },
  likeMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.likeMessage,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.likeMessageConsumer,
  },
  saveMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.saveMessageChanges,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.saveMessageChangesConsumer,
  },
  getMessageLogs: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.getMessageLogs,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.getMessageLogsConsumer,
  },
  createMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.createMessage,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.createMessageConsumer,
  },
  exportMessages: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.exportMessages,
    [PROJECT_VARIANTS.CONSUMER]: consumerScoutActions.exportMessagesConsumer,
  },
  uploadFile: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.uploadFile,
    [PROJECT_VARIANTS.CONSUMER]: scoutActions.uploadFile,
  },
  clearBoard: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.clearBoard,
  },
  clearAll: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.clearAll,
  },
  reclaimBackup: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.reclaimBackup,
  },
  restoreMessage: {
    [PROJECT_VARIANTS.ADMIN]: scoutActions.restoreMessage,
  },
};

export default scoutActionsMapping;
